module.exports = __webpack_public_path__ + "img/electric-mining-drill-N-drill-shadow.45ed85ab.png";